export const formatDate = (date) => {
  const dateISO = date.toISOString()

  return dateISO.substr(0, dateISO.indexOf('.'))
}
